<template>
  <v-container fluid>
    <v-card flat class="rounded-lg py-2" height="100%">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle font-weight-black text-h5" style="width: 200px;">系統使用紀錄</div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="exportFile" :loading="isExporting">匯出</v-btn>
        </div>
        <v-spacer>
        </v-spacer>
        <div class="text-center mr-5">
          <v-pagination
            circle
            v-model="page"
            :length="pageCount"
            total-visible=7
          ></v-pagination>
        </div>
        <v-divider
          class="tableDivider mr-5"
          vertical
          inset
        >
        </v-divider>
        <div class="text-center mr-5 contentCenter">
          共{{total}}筆
        </div>
        <!-- 每頁顯示筆數 -->
        <div style="width:180px">
          <v-select
            :items="rowsList"
            outlined
            class="rounded-lg"
            dense
            v-model="rows"
            hide-details
            prefix="每頁顯示"
            suffix="筆"
          >
          </v-select>
        </div>
      </div>
      <v-data-table
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        hide-default-footer
        :items="eventList"
        :headers="headers"
        hide-default-header
        :items-per-page="rows"
        :loading="isLoading"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th
                class="greyTh"
                v-for="header in headers"
                :key="header.value"
              >
                <div
                  :style="'width:'+header.width+'px'"
                  @click="changeSort(header)"
                  class="sortableThDiv"
                >
                  <div class="sortableThDivText">
                    {{header.text}}
                  </div>
                  <div v-if="header.sortable&&sortItem===header.value">
                    <v-icon v-if="sortOrder">mdi-chevron-down</v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td
              v-for="header in headers"
              :key="header.value"
              class="tableTD"
            >
              <div>
                {{item[header.value]}}
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          no data available
        </template>
      </v-data-table>
      <!-- 搜尋 sidebar -->
      <v-navigation-drawer
        app
        clipped
        class="rounded-lg mt-3"
        :width="sidebarWidth"
        height="850"
        permanent
      >
        <div class="rowDiv">
          <v-card-title v-if="sidebarOpen" class="headline font-weight-bold">篩選條件</v-card-title>
          <v-spacer>
          </v-spacer>
          <v-icon
            size = "30"
            style="cursor: pointer;"
            class="mr-5"
            v-if='sidebarOpen'
            @click="sidebarOpen=!sidebarOpen"
          >
            mdi-arrow-expand-left
          </v-icon>
          <v-icon
            size = "30"
            style="cursor: pointer;"
            class="mr-5 mt-5"
            v-else
            @click="sidebarOpen=!sidebarOpen"
          >
            mdi-tune-variant
          </v-icon>
        </div>
        <v-divider></v-divider>
        <div v-if="sidebarOpen">
          <v-card-title style="height:50px" class="searchTitle">作業時間(起)</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-menu
              ref="startDateMenu"
              v-model="startDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="startDate"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  class="rounded-lg"
                  dense
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                @input="startDateMenu = false"
                no-title
                scrollable
              >
              </v-date-picker>
            </v-menu>
          </div>
          <v-card-title style="height:50px" class="searchTitle">作業時間(迄)</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-menu
              ref="endDateMenu"
              v-model="endDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="endDate"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  class="rounded-lg"
                  dense
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="endDate"
                @input="endDateMenu = false"
                no-title
                scrollable
              >
              </v-date-picker>
            </v-menu>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">人員編號</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-text-field
              v-model="searchUserId"
              class="rounded-lg"
              dense
              outlined
              hide-details
            ></v-text-field>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">作業資訊</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-text-field
              v-model="searchEvents"
              class="rounded-lg"
              dense
              outlined
              hide-details
            ></v-text-field>
          </div>
        </div>
      </v-navigation-drawer>
    </v-card>
  </v-container>
</template>
<script>
// import axios from 'axios'
// import router from '../router'
import Service from '../service/service'
export default {
  name: 'Sys_Log_Info',
  data: () => ({
    isLoading: false,
    isExporting: false,
    headers: [
      { text: '人員編號', value: 'user_id',  width: '110', sortable: true },
      { text: '作業資訊', value: 'events', width: '500', sortable: true },
      { text: '作業時間', value: 'dt',  width: '150', sortable: true },
    ],
    startDateMenu: false,
    startDate: '',
    endDateMenu: false,
    endDate: '',
    rows: 10,
    sortItem: 'addsign_workingnumber',
    sortOrder: false,
    total: 0,
    pageCount: 0,
    page: 1,
    rowsList: [10, 20, 30, 40, 50],
    controlPermission: [],
    eventList: [],
    sidebarOpen: true,
    sidebarWidth: 260,
    searchUserId: '',
    searchEvents: ''
  }),
  mounted: function () {
    // this.path = this.$router.currentRoute.path
    // const control = this.permissions.find(x => x.path === this.path)
    // this.controlPermission = control ? control.permission : []
    this.setDefultDate()
  },
  watch: {
    page () {
      this.getPageData()
    },
    sidebarOpen () {
      if (this.sidebarOpen) {
        this.sidebarWidth = 260
      } else {
        this.sidebarWidth = 70
      }
    },
    startDate () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    endDate () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchUserId () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchEvents () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    rows () {
      this.page === 1 ? this.getPageData() : this.page = 1
    }
  },
  props: {
    user: null,
    permissions: null,
    isMobile: null
  },
  computed: {
    order () {
      if (this.sortOrder) {
        return 'desc'
      } else {
        return 'asc'
      }
    }
  },
  methods: {
    showAlert (type, message) {
      var alert = {
        alertType: null,
        alertMessage: '',
        alertIcon: null
      }
      if (type === 'success') {
        alert.alertType = 'success'
        alert.alertIcon = 'mdi-check-circle'
      } else {
        alert.alertType = 'error'
        alert.alertIcon = 'mdi-alert-circle'
      }
      alert.alertMessage = message
      this.$emit('setAlert', alert)
    },
    changeSort (header) {
      if (!header.sortable) return

      if (header.value === this.sortItem) {
        this.sortOrder = !this.sortOrder
      } else {
        this.sortOrder = true
        this.sortItem = header.value
      }
      this.getPageData()
    },
    setDefultDate () {
      var d = new Date()
      var endDate = d.getFullYear()
      if ((d.getMonth() + 1) < 10) {
        endDate = endDate + '-0' + (d.getMonth() + 1)
      } else {
        endDate = endDate + '-' + (d.getMonth() + 1)
      }
      if ((d.getDate()) < 10) {
        endDate = endDate + '-0' + (d.getDate())
      } else {
        endDate = endDate + '-' + (d.getDate())
      }
      this.startDate = this.endDate = endDate
    },
    getPageData () {
      this.isLoading = true
      this.pageCount = 0
      this.eventList = []
      var searchStartDate = {
        name: 'startDate',
        value: this.startDate,
        displayType: 'thanorequal'
      }
      var searchEndDate = {
        name: 'endDate',
        value: this.endDate,
        displayType: 'lessorequal'
      }
      var searchUserId = {
        name: 'user_id',
        value: this.searchUserId,
        displayType: '='
      }
      var searchEvents = {
        name: 'events',
        value: this.searchEvents,
        displayType: '='
      }
      var wheres = [searchStartDate, searchEndDate, searchUserId, searchEvents]
      var parm = {
        page: this.page,
        rows: this.rows,
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: 'sys_log_info/getPageData'
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            this.total = response.data.total
            this.pageCount = Math.ceil(this.total / this.rows)
            this.eventList = response.data.rows
          }
        })
      .finally(() => {
        this.isLoading = false
      })
    },
    exportFile () {
      this.isExporting = true
      var searchStartDate = {
        name: 'startDate',
        value: this.startDate,
        displayType: 'thanorequal'
      }
      var searchEndDate = {
        name: 'endDate',
        value: this.endDate,
        displayType: 'lessorequal'
      }
      var searchUserId = {
        name: 'user_id',
        value: this.searchUserId,
        displayType: '='
      }
      var searchEvents = {
        name: 'events',
        value: this.searchEvents,
        displayType: '='
      }
      var wheres = [searchStartDate, searchEndDate, searchUserId, searchEvents]
      var parm = {
        wheres: JSON.stringify(wheres),
        url: 'sys_log_info/Export'
      }
      Service.exportFile(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            var filename = '系統使用紀錄.xlsx'
            var downloadURL = ''
            var binaryData = []
            binaryData.push(response.data)
            downloadURL = URL.createObjectURL(new Blob(binaryData, { type: 'application/octet-stream' }))
            var link = document.createElement('a')
            link.href = downloadURL
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            link = null
          }
        })
      .finally(() => {
        this.isExporting = false
      })
    },
  }
}
</script>
